import api from './index.js';
import SecureLS from 'secure-ls';

const ls = new SecureLS({encodingType: 'aes'});

export async function login(email, password) {
    try {
        const response = await api.post('/users/login', { email, password });
        console.log('logged in: ', response.data);
        ls.set('jwt', response.data.token);
        return response
    } catch (err) {
        console.error(err)
    }
}

export async function logout() {
    try {
        await api.post('/users/logout');
    } catch (error) {
        console.error(error)
    }
}
